// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2j7yB","col":"styles_col__aSa2u"};